import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import 'iview/dist/styles/iview.css';
import common from './common/index'
import store from './store/index'
import router from './router'
import './plugins/iview.js'
import {LoadingBar} from 'iview';
Vue.config.productionTip = false;

import VueI18n from "vue-i18n";
Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: "zh-CN", // 语言标识
  messages: {
    "zh-CN": require("./common/lang/zh"), // 中文语言包
    "en-US": require("./common/lang/en") // 英文语言包
  }
});


import  vueTitle  from 'vue-wechat-title';
Vue.use(LoadingBar);
Vue.use(vueTitle);
router.beforeEach((to, from, next) => {
  /*路由发生改变修改页面的title */
  LoadingBar.start();
  if(to.meta.title) {
    document.title = to.meta.title
  }
  next();
});

new Vue({
  common,
  store,
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
